import { TablePreview } from "@/app/preview";

export const TablePreviewTab = ({
  workbookId,
  tableId,
}: {
  workbookId: string;
  tableId: string;
}) => {
  return <TablePreview workbookId={workbookId} tableId={tableId} />;
};
